import { ReactComponent as GoogleMark } from "../assets/auth/google-g.svg";
import { ReactComponent as TelegramMark } from "../assets/auth/telegram-plane.svg";
import downloadBanner from "../assets/auth/downloadBanner";
import UnavailableFeatureDialog from "./UnavailableFeatureDialog";
import React, { useEffect, useState,useRef } from "react";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useForm ,Controller} from "react-hook-form";
import { apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { toast } from "wc-toast";
import jwt_decode from "jwt-decode";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import OutsideClickHandler from "react-outside-click-handler";
import { t } from "i18next";
import { Form } from "react-bootstrap";
import { isEmpty } from "lodash";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
const Register = ({ setRegisterModal }) => {
    const inputRef = useRef(null);

  const [unavailableFeature, setUnavailableFeature] = useState(null);
  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const setUser = useContextSelector(AuthContext, (ctx) => ctx.setUser);
  const setLoginModal = useContextSelector(AuthContext, (ctx) => ctx.setLoginModal);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const passwordValue = watch("password");

  useEffect(() => {
    document.body.classList.add("on-show");
    return () => document.body.classList.remove("on-show");
  }, []);

  const onSubmit = async (body) => {
    localStorage.clear();
    try {
      const { status, data: response_users1 } = await apiPost(apiPath.registerUser, {
        username: body?.username,
        password: body?.password,
         phone_number: body?.mobile?.substring(
                inputRef?.current?.state.selectedCountry?.countryCode?.length,
                body?.mobile?.toString()?.length
              ),
              country_code:
                inputRef?.current?.state.selectedCountry?.countryCode,
        uniqueId: Math.random() * 10000,
      });
      if (status === 200) {
        if (response_users1.success) {
          localStorage.setItem("token", response_users1?.results?.token);
          localStorage.setItem("refresh_token", response_users1?.results?.refresh_token);
          setUser(jwt_decode(response_users1?.results.token));
          sessionStorage.setItem("chorki-show-rewards", "1");
          navigate("/");
          window.location.reload();
        } else {
          toast.error(response_users1?.message || "Registration failed");
        }
      } else {
        toast.error(response_users1?.message || "Registration failed");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Registration failed");
    }
  };

  return (
    <div className="v--modal-overlay" aria-expanded="true" data-modal="registerModal">
      {unavailableFeature && <UnavailableFeatureDialog feature={unavailableFeature} onClose={() => setUnavailableFeature(null)} />}
      <div className="v--modal-background-click">
        <div className="v--modal-top-right" />
        <div
          role="dialog"
          aria-modal="true"
          className="v--modal-box v--modal"
          style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100dvh" }}
        >
          <OutsideClickHandler onOutsideClick={() => { if (!unavailableFeature) setRegisterModal(false); }}>
            <div style={{ width: "fit-content" }} className="tcg_modal_wrap hasBg">
              <div onClick={() => setRegisterModal(false)} className="tcg_modal_close special">
                <div className="tcg_modal_close_text" />
              </div>
              <div className="tcg_modal_body">
                <div className="regs_bg">
                  <div className="register_wrapper">
                    <div className="register_content">
                      <div className="register-title">
                        <img className="ref-auth-logo" src="/assets/chorki/logo.svg" alt="chorki" />
                        <div className="register-title__text">{t("Register")}</div>
                      </div>
                      <div className="form_container">
                        <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off" className="register-form">
                          <div className="form_item">
                            <div className="label-box">
                              <div className="label-text isRequire">{t("Username")}</div>
                            </div>
                            <div className="item_box">
                              <input
                                type="text"
                                spellCheck="false"
                                placeholder={`* ${t("Username")}`}
                                className="username_input"
                                aria-required="true"
                                {...register("username", {
                                  required: t("Enter_Username"),
                                  minLength: { value: 3, message: t("Min3User") },
                                  maxLength: { value: 30, message: t("Max30User") },
                                  pattern: {
                                    value: /^[A-Za-z0-9]{3,30}$/,
                                    message: t("Enter_Valid_Username"),
                                  },
                                })}
                              />
                            </div>
                            {!isEmpty(errors?.username?.message) && (
                              <div className="panel panel-default">
                                <strong className="on">{errors?.username?.message}</strong>
                              </div>
                            )}
                          </div>

                          <div className="form_item password">
                            <div className="label-box">
                              <div className="label-text isRequire">{t("Password")}</div>
                            </div>
                            <div className="item_box">
                              <input
                                type={showPassword ? "text" : "password"}
                                autoComplete="new-password"
                                placeholder={`* ${t("Password")}`}
                                className="password_input"
                                aria-required="true"
                                {...register("password", {
                                  required: t("Enter_Password"),
                                  minLength: { value: 6, message: t("PasswordMin") },
                                  maxLength: { value: 20, message: t("PasswordMax") },
                                })}
                              />
                              <button
                                type="button"
                                className="ref-auth-eye"
                                aria-label={showPassword ? "Hide password" : "Show password"}
                                onClick={() => setShowPassword((open) => !open)}
                              >
                                {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
                              </button>
                            </div>
                            {!isEmpty(errors?.password?.message) && (
                              <div className="panel panel-default">
                                <strong className="on">{errors?.password?.message}</strong>
                              </div>
                            )}
                          </div>

                          <div className="form_item password">
                            <div className="label-box">
                              <div className="label-text isRequire">Confirm password</div>
                            </div>
                            <div className="item_box">
                              <input
                                type={showPassword2 ? "text" : "password"}
                                autoComplete="new-password"
                                placeholder="* Confirm password"
                                className="password_input"
                                aria-required="true"
                                {...register("confirmPassword", {
                                  required: "Confirm your password",
                                  validate: (value) => value === passwordValue || "Passwords do not match",
                                })}
                              />
                              <button
                                type="button"
                                className="ref-auth-eye"
                                aria-label={showPassword2 ? "Hide password" : "Show password"}
                                onClick={() => setShowPassword2((open) => !open)}
                              >
                                {showPassword2 ? <FaRegEye /> : <FaRegEyeSlash />}
                              </button>
                            </div>
                            {!isEmpty(errors?.confirmPassword?.message) && (
                              <div className="panel panel-default">
                                <strong className="on">{errors?.confirmPassword?.message}</strong>
                              </div>
                            )}
                          </div>
                           <div className="form_item password">
                            <div className="label-box">
                              <div className="label-text isRequire">Mobile</div>
                            </div>
                       
                         
     <div className="item_box">
                          <Controller
                            control={control}
                            name="mobile"
                            rules={{
                              required: t("Enter_Mobile"),
                              validate: (value) => {
                                let inputValue = value
                                  ?.toString()
                                  ?.slice(
                                    inputRef?.current?.state?.selectedCountry
                                      ?.countryCode?.length,
                                    value?.length,
                                  );
                                if (inputValue?.length < 10) {
                                  return t("MobileMin");
                                } else if (inputValue?.length > 12) {
                                  return t("MobileMax");
                                } else {
                                  return true;
                                }
                              },
                            }}
                            render={({ field: { ref, ...field } }) => (
                              <>
                                <PhoneInput
                                  {...field}
                                  inputExtraProps={{
                                    ref,
                                    required: true,
                                    autoFocus: true,
                                  }}
                                  ref={inputRef}
                                  className="inputrefNew"
                                  placeholder="Mobile Number"
                                  country={"bd"}
                                  disableDropdown={true}
                                  countryCodeEditable={false}
                                />
                              </>
                            )}
                          />
                        </div>

                        {!isEmpty(errors?.mobile?.message) && (
                          <div className="panel panel-default">
                            <strong className="on">
                              {errors?.mobile?.message}
                            </strong>
                          </div>
                        )}
                      </div>

                          <div className="form_item reg-btn-wrap">
                            <button type="submit" name="button" className="register_btn">
                              {t("Register")}
                            </button>
                          </div>
                        </Form>

                        <div className="ref-auth-social">
                          <div className="ref-auth-social-tip">
                            <span>or connect with</span>
                          </div>
                          <div className="ref-auth-social-row">
                            <button
                              type="button"
                              className="ref-auth-social-btn google square"
                              aria-label="Google"
                              onClick={() => setUnavailableFeature("Google sign-in")}
                            >
                              <GoogleMark aria-hidden="true" />
                            </button>
                            <button
                              type="button"
                              className="ref-auth-social-btn telegram square"
                              aria-label="Telegram"
                              onClick={() => setUnavailableFeature("Telegram sign-in")}
                            >
                              <TelegramMark aria-hidden="true" />
                            </button>
                          </div>
                        </div>

                        <a
                          className="ref-auth-oneone"
                          href="https://1.1.1.1/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img src={downloadBanner} alt="Download 1.1.1.1" />
                        </a>

                        <div className="tip1">
                          <span>{t("Alreadyhaveanaccount")}</span>{" "}
                          <span
                            onClick={() => {
                              setLoginModal(true);
                              setRegisterModal(false);
                            }}
                            className="register-tip"
                          >
                            {t("Login")}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </OutsideClickHandler>
        </div>
      </div>
    </div>
  );
};

export default Register;
